import dayjs, { Dayjs } from "dayjs";

export const OBSERVATION_DATE_MAX_DAYS_PAST = 6;

export const getMinObservationDate = (now: Dayjs = dayjs()) =>
  now.startOf("day").subtract(OBSERVATION_DATE_MAX_DAYS_PAST, "day");

export const getMaxObservationDate = (now: Dayjs = dayjs()) =>
  now.startOf("day");

export const getLearnerObservationDateError = (
  caseDate: Dayjs | null,
  now: Dayjs = dayjs(),
): string | null => {
  if (!caseDate) return "Please select a case date";
  const day = caseDate.startOf("day");
  if (day.isBefore(getMinObservationDate(now))) {
    return "Observation date must be within the last 6 days";
  }
  if (day.isAfter(getMaxObservationDate(now))) {
    return "Observation date can't be in the future";
  }
  return null;
};
